<template>
  <div :class="classes">ch{{ ch }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  ch: 1 | 2;
  size?: 's' | 'm' | 'l';
}

const props = withDefaults(defineProps<Props>(), {
  ch: 1,
  size: 'm',
});

const classes = computed(() => ['channel', [`channel--ch${props.ch}`], [`channel--${props.size}`]]);
</script>

<style lang="scss" scoped>
.channel {
  color: white;
  font-weight: 500;
  text-align: center;

  &--ch1 {
    background-color: $color-primary;
  }

  &--ch2 {
    background-color: $color-secondary;
  }

  &--s {
    width: 31px;
    height: 18px;
    font-size: 10px;
    line-height: 18px;
  }

  &--m {
    width: 35px;
    height: 24px;
    font-size: 12px;
    line-height: 24px;
  }

  &--l {
    width: 39px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}
</style>
